
























import { Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  @Prop() appid!: string;

  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "你确定要绑定该微信吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch("oplatformapps/bindTester", {
              appid: this.appid,
              wechatid: fieldValues.wechatid
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }
}
